import { Grid } from '@mui/material';

export const OptionsCount = ({ count }: { count: number }) => {
  return (
    <Grid
      sx={{
        borderRadius: '8px',
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '14px',
        color: '#FFF',
        padding: '4px 12px',
        background: '#4D6EF5',
      }}
    >
      {count}
    </Grid>
  );
};
